module.exports = __webpack_public_path__ + "static/media/cross-thin-24.8c36c8c5.svg";